import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CounselingStoreState {
  counselingSessionId: number | null;
  setCounselingSessionId: (id: number | null) => void;
  clearCounselingSessionId: () => void;
}

export const useCounselingStore = create<CounselingStoreState>()(
  persist(
    (set) => ({
      counselingSessionId: null,
      setCounselingSessionId: (id) => set({ counselingSessionId: id }),
      clearCounselingSessionId: () => set({ counselingSessionId: null }),
    }),
    {
      name: 'counseling-store', // unique name for localStorage key
    }
  )
);
